import { useState, useEffect } from 'react';

const defaultScrollState = { right: false, left: false, scrollLeft: 0 };

export default function useTableScrollState(
  containerRef,
  { scrollableSelector, resizableSelector } = {}
) {
  const [scrollState, setScrollState] = useState(defaultScrollState);

  useEffect(() => {
    const toggleScrollState = ({ target: { offsetWidth, scrollWidth, scrollLeft } }) => {
      const hasHScroll = scrollWidth > offsetWidth;
      const hasScroll = hasHScroll;

      if (hasScroll) {
        const nextState = {
          right: scrollWidth > offsetWidth + scrollLeft,
          left: scrollLeft > 0,
          scrollLeft,
        };

        setScrollState((prevState) => {
          const hScrollChanged =
            prevState.left !== nextState.left ||
            prevState.right !== nextState.right ||
            prevState.scrollLeft !== nextState.scrollLeft;

          if (hScrollChanged) return nextState;
          return prevState;
        });
      } else {
        setScrollState(defaultScrollState);
      }
    };

    // Scrollable container
    const scrollableContainer = scrollableSelector
      ? containerRef.current.querySelector(scrollableSelector)
      : containerRef.current;

    // Resizeble container
    let resizableContainer;
    let resizeObserver;

    if (resizableSelector) {
      resizableContainer = scrollableContainer.querySelector(resizableSelector);
      resizeObserver = new ResizeObserver(() => {
        toggleScrollState({ target: scrollableContainer });
      });

      resizeObserver.observe(resizableContainer);
    }
    scrollableContainer.addEventListener('scroll', toggleScrollState);

    return () => {
      scrollableContainer.removeEventListener('scroll', toggleScrollState);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, []);

  return scrollState;
}
